import { formField } from 'framework/components/hoc/formField';
import { RichEditor } from './RichEditor';
import { RichEditorFieldProps } from './Types';

export const RichEditorField: React.StatelessComponent<RichEditorFieldProps> = formField(RichEditor) as any;
